import { render, staticRenderFns } from "./Comprobantes.vue?vue&type=template&id=ecfd1fd8"
import script from "./Comprobantes.vue?vue&type=script&lang=js"
export * from "./Comprobantes.vue?vue&type=script&lang=js"
import style0 from "./Comprobantes.vue?vue&type=style&index=0&id=ecfd1fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports